import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss']
})
export class FiltersComponent implements OnInit {

  constructor() { }

  @Input() filterIsExpanded: boolean = false;
  @Input() filters;
  filtersSelected:   any;

  ngOnInit() {
    this.getCheckedItems();
  }

  getCheckedItems() {
    this.filtersSelected = [];
    this.filters.forEach((element) => {
      element.filters.forEach((item) => {
        if (item.selected) {
          this.filtersSelected.push(item);
        }
      });
    });
  }
}
